import { IconProps } from "./IconProps";

export const CrossIcon24 = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00091 7.0009C6.61038 7.39143 6.61038 8.02459 7.00091 8.41512L10.586 12.0002L7.00091 15.5854C6.61038 15.9759 6.61038 16.6091 7.00091 16.9996C7.39143 17.3901 8.0246 17.3901 8.41512 16.9996L12.0002 13.4144L15.5854 16.9996C15.9759 17.3901 16.6091 17.3901 16.9996 16.9996C17.3901 16.6091 17.3901 15.9759 16.9996 15.5854L13.4144 12.0002L16.9996 8.41513C17.3901 8.02461 17.3901 7.39144 16.9996 7.00092C16.609 6.61039 15.9759 6.61039 15.5854 7.00092L12.0002 10.586L8.41512 7.0009C8.0246 6.61038 7.39143 6.61038 7.00091 7.0009Z"
        fill="white"
      />
    </svg>
  );
};
